//# sourceMappingURL=my-default-month.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-default-month.interface.js
// module id = 751
// module chunks = 3